import styled, { keyframes } from 'styled-components';
import { colorPrimary } from '../../theme';

/* ===== HERO / SLIDER ===== */
export const HeroSection = styled.section`
	position: relative;
	background: url('${process.env.PUBLIC_URL}/images/banner-fited.png') center center / cover no-repeat;
	background-color: #1a1a2e;
	min-height: 480px;
	display: flex;
	align-items: center;
	padding: 60px 0;

	&::before {
		content: '';
		position: absolute;
		inset: 0;
		background: rgba(0, 0, 0, 0.5);
	}

	@media (max-width: 991px) {
		padding: 40px 0;
		min-height: auto;
	}
`;

export const HeroInner = styled.div`
	position: relative;
	z-index: 1;
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	width: 100%;
	display: flex;
	align-items: center;
	gap: 40px;

	@media (max-width: 991px) {
		flex-direction: column;
		text-align: center;
	}
`;

export const HeroText = styled.div`
	flex: 1;

	h1 {
		font-size: 36px;
		font-weight: 300;
		color: #fff;
		margin: 0 0 20px;
		line-height: 1.3;

		span {
			color: ${colorPrimary};
			font-weight: 700;
		}
	}

	p {
		font-size: 16px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.6;
		margin: 0;
	}

	@media (max-width: 991px) {
		h1 {
			font-size: 26px;
		}
		p {
			font-size: 14px;
		}
	}
`;

export const HeroLoginCard = styled.div`
	width: 360px;
	flex-shrink: 0;
	background: rgba(255, 255, 255, 0.1);
	backdrop-filter: blur(6px);
	border: 1px solid rgba(255, 255, 255, 0.15);
	border-radius: 6px;
	padding: 30px 28px;

	h4 {
		color: #fff;
		font-size: 16px;
		font-weight: 500;
		margin: 0 0 20px;
		text-align: center;
	}

	@media (max-width: 991px) {
		width: 100%;
		max-width: 380px;
	}
`;

export const HeroForm = styled.form`
	display: flex;
	flex-direction: column;
	gap: 14px;
`;

export const HeroInput = styled.input`
	width: 100%;
	padding: 12px 16px;
	border: 1px solid rgba(255, 255, 255, 0.3);
	border-radius: 4px;
	background: rgba(255, 255, 255, 0.08);
	color: #fff;
	font-size: 14px;
	font-family: 'Poppins', sans-serif;
	outline: none;
	transition: border-color 0.25s;
	box-sizing: border-box;

	&::placeholder {
		color: rgba(255, 255, 255, 0.5);
	}

	&:focus {
		border-color: ${colorPrimary};
	}

	&:disabled {
		opacity: 0.6;
		cursor: not-allowed;
	}
`;

export const ForgotLink = styled.a`
	color: rgba(255, 255, 255, 0.7);
	font-size: 13px;
	text-decoration: none;
	transition: color 0.2s;

	&:hover {
		color: ${colorPrimary};
	}
`;

export const HeroFormInfo = styled.p`
	text-align: center;
	font-size: 12px;
	color: rgba(255, 255, 255, 0.5);
	margin: 4px 0 0;
`;

export const HeroErrorAlert = styled.div`
	background: rgba(255, 60, 60, 0.15);
	border: 1px solid rgba(255, 60, 60, 0.4);
	border-radius: 4px;
	padding: 8px 12px;
	color: #ff8888;
	font-size: 13px;
`;

const bounceDown = keyframes`
	0%, 100% { transform: translateY(0); }
	50% { transform: translateY(10px); }
`;

export const ScrollArrow = styled.div`
	position: absolute;
	bottom: 20px;
	left: 50%;
	transform: translateX(-50%);
	z-index: 2;

	a {
		color: #fff;
		font-size: 20px;
		animation: ${bounceDown} 1.5s ease infinite;
		display: block;
	}
`;

/* ===== QUEM SOMOS ===== */
export const AboutSection = styled.section`
	padding: 70px 0;
	background: #fff;
`;

export const AboutInner = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	display: flex;
	align-items: center;
	gap: 40px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const AboutImg = styled.div`
	flex: 1;

	img {
		width: 100%;
		border-radius: 6px;
		display: block;
	}
`;

export const AboutContent = styled.div`
	flex: 1;

	p {
		font-size: 14px;
		color: #555;
		line-height: 1.8;
		text-align: justify;
		margin: 0 0 20px;
	}
`;

/* ===== PRODUTOS ===== */
export const ProductsSection = styled.section`
	padding: 70px 0;
	background: #f5f5f5;
`;

export const ProductsInner = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
`;

export const ProductsGrid = styled.div`
	display: flex;
	gap: 30px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const ProductCard = styled.div`
	flex: 1;
	background: #fff;
	border-radius: 6px;
	padding: 36px 30px;
	text-align: center;
	box-shadow: 0 2px 20px rgba(0, 0, 0, 0.06);
	transition: transform 0.3s, box-shadow 0.3s;

	&:hover {
		transform: translateY(-4px);
		box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
	}
`;

export const ProductIcon = styled.div`
	margin-bottom: 20px;

	img {
		max-height: 55px;
	}
`;

export const ProductTitle = styled.div`
	font-size: 20px;
	font-weight: 600;
	color: #333;
	margin-bottom: 16px;
`;

export const ProductText = styled.div`
	font-size: 14px;
	color: #555;
	line-height: 1.7;
	text-align: justify;
	margin-bottom: 20px;
`;

export const StoreLinks = styled.ul`
	list-style: none;
	padding: 0;
	margin: 16px 0 0;
	display: flex;
	justify-content: center;
	gap: 12px;

	img {
		height: 38px;
		transition: opacity 0.2s;

		&:hover {
			opacity: 0.8;
		}
	}
`;

/* ===== APLICATIVOS ===== */
export const AppsSection = styled.section`
	padding: 70px 0;
	background: #fff;
`;

export const AppsInner = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	display: flex;
	align-items: center;
	gap: 40px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const AppsContent = styled.div`
	flex: 1.4;

	p {
		font-size: 14px;
		color: #555;
		line-height: 1.8;
		text-align: justify;
		margin: 0 0 16px;

		strong {
			color: #333;
		}
	}
`;

export const AppsImages = styled.div`
	flex: 1;
	display: flex;
	gap: 12px;
	justify-content: center;
	overflow: hidden;

	img {
		max-height: 400px;
		border-radius: 12px;
		box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
	}

	@media (max-width: 767px) {
		img {
			max-height: 280px;
		}
	}
`;

/* ===== PORTAL / AVALIADOR ===== */
export const FeatureSection = styled.section<{ $bgColor?: string }>`
	padding: 70px 0;
	background: ${({ $bgColor }) => $bgColor || '#f5f5f5'};
`;

export const FeatureInner = styled.div<{ $reverse?: boolean }>`
	max-width: 1170px;
	margin: 0 auto;
	padding: 0 15px;
	display: flex;
	align-items: center;
	gap: 40px;

	${({ $reverse }) => $reverse && 'flex-direction: row-reverse;'}

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const FeatureImg = styled.div`
	flex: 1;
	min-height: 300px;
	border-radius: 6px;
	background-size: cover;
	background-position: center;
	background-color: #ddd;

	@media (max-width: 767px) {
		width: 100%;
		min-height: 220px;
	}
`;

export const FeatureContent = styled.div`
	flex: 1;

	p {
		font-size: 14px;
		color: #555;
		line-height: 1.8;
		text-align: justify;
		margin: 0 0 16px;

		strong {
			color: #333;
		}
	}
`;

export const FeatureTwoCol = styled.div`
	max-width: 1170px;
	margin: 0 auto;
	padding: 40px 15px 0;
	display: flex;
	gap: 40px;

	@media (max-width: 767px) {
		flex-direction: column;
	}
`;

export const FeatureCol = styled.div`
	flex: 1;

	p {
		font-size: 14px;
		color: #555;
		line-height: 1.8;
		text-align: justify;
		margin: 0 0 16px;
	}
`;
